import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import ShowOptionalLabel from '../ShowOptionalLabel'
import ShowOptionalField from '../ShowOptionalField'
import ShowTipoSoggetto from './ShowTipoSoggetto'
import OrgMiniView from './OrgMiniView'
import DipMiniView from './DipMiniView'
import ModalConfirm from '../ModalConfirm'
import LocalDate from '../LocalDate'
import LocalTime from '../LocalTime'

class RubricaTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let c = this.props.item

        let btnEdit = null;
        let btnDelete = null;
        if (this.props.readOnly === false){
            btnEdit = <Link  className="ui blue icon button" to={`/app/rubrica/edit/${c.idSoggetto}`}>
                        <i
                            className="edit icon"

                        ></i>
                    </Link>;
            btnDelete = <ModalConfirm
                            msg={"Stai per cancellare il soggetto: " + c.nomeCompleto}
                            onClickOk={(ev) => (this.props.onDeleteSoggetto(ev, c))}
                        >
                            <a className="ui red icon button"><i className="trash icon"/></a>
                        </ModalConfirm>;
        }

        return (
            <tr>
                <td className="">
                    <div className="content">
                        <Link to={`/app/rubrica/view/${c.idSoggetto}`}>{c.tit} {c.nomeCognome}</Link>&nbsp;<ShowTipoSoggetto soggetto={c}/>
                        <div className="sub header">
                            <div>{c.indirizzo} {c.cap} {c.citta} {c.provincia} {c.stato}</div>
                            <div><ShowOptionalField label="C.Fisc." value={c.cfisc}/><ShowOptionalField label="P.IVA" value={c.piva}/></div>
                            <div className="sub header">
                                <ShowOptionalLabel title="Telefono 1"    value={c.telefono1} icon="voulme control phone" extraClassName="left floated" />
                                <ShowOptionalLabel title="Telefono 2"    value={c.telefono2} icon="voulme control phone" extraClassName="left floated"  />
                                <ShowOptionalLabel title="Cellulare"    value={c.cellulare} icon="mobile" extraClassName="left floated"  />
                                <ShowOptionalLabel title="FAX"    value={c.fax} icon="fax" extraClassName="left floated"  />
                                <ShowOptionalLabel title="e-mail"    value={c.email} icon="mail" extraClassName="left floated"  />
                                <ShowOptionalLabel title="PEC"    value={c.pec} icon="mail" extraClassName="left floated"  />
                                <ShowOptionalLabel title="Cellulare personale"    value={c.perCellulare} icon="mobile" extraClassName="left floated"  />
                                <ShowOptionalLabel title="e-mail personale"    value={c.perEmail} icon="mail" extraClassName="left floated"  />
                            </div>
                            <div className="content">
                                <i>{c.note}</i>
                            </div>
                            <div className="content">
                                Creato il {c.creatoIl ?  <b><LocalDate data={c.creatoIl } /> <LocalTime data={c.creatoIl } /></b> : <b>?</b>} da <b>{c.creatoDa ? c.creatoDa.username : '?'}</b>&nbsp;
                                Modificato il {c.modificatoIl ?  <b><LocalDate data={c.modificatoIl } /> <LocalTime data={c.modificatoIl } /></b> : <b>?</b>} da <b>{c.modificatoDa ? c.modificatoDa.username : '?'}</b>
                            </div>
                        </div>
                    </div>
                </td>
                <td className="">

                    <div className="content">
                        <Link to={`/app/rubrica/view/${c.idSoggetto}`}>{c.idDipartimento.nomeCompleto}</Link>
                        <DipMiniView item={c.idDipartimento} />
                    </div>
                    <div className="content">
                        Creato il {c.idDipartimento.creatoIl ?  <b><LocalDate data={c.idDipartimento.creatoIl } /> <LocalTime data={c.idDipartimento.creatoIl } /></b> : <b>?</b>} da <b>{c.idDipartimento.creatoDa ? c.idDipartimento.creatoDa.username : '?'}</b>&nbsp;
                        Modificato il {c.idDipartimento.modificatoIl ?  <b><LocalDate data={c.idDipartimento.modificatoIl } /> <LocalTime data={c.idDipartimento.modificatoIl } /></b> : <b>?</b>} da <b>{c.idDipartimento.modificatoDa ? c.idDipartimento.modificatoDa.username : '?'}</b>
                    </div>
                </td>
                <td className="">
                    <div className="content">
                        <Link to={`/app/rubrica/view/${c.idSoggetto}`}>{c.idDipartimento.idOrganizzazione.nomeCompleto}</Link>
                        <OrgMiniView item={c.idDipartimento.idOrganizzazione} />
                    </div>
                    <div className="content">
                        Creato il {c.idDipartimento.idOrganizzazione.creatoIl ?  <b><LocalDate data={c.idDipartimento.idOrganizzazione.creatoIl } /> <LocalTime data={c.idDipartimento.idOrganizzazione.creatoIl } /></b> : <b>?</b>} da <b>{c.idDipartimento.idOrganizzazione.creatoDa ? c.idDipartimento.idOrganizzazione.creatoDa.username : '?'}</b>&nbsp;
                        Modificato il {c.idDipartimento.idOrganizzazione.modificatoIl ?  <b><LocalDate data={c.idDipartimento.idOrganizzazione.modificatoIl } /> <LocalTime data={c.idDipartimento.idOrganizzazione.modificatoIl } /></b> : <b>?</b>} da <b>{c.idDipartimento.idOrganizzazione.modificatoDa ? c.idDipartimento.idOrganizzazione.modificatoDa.username : '?'}</b>
                    </div>
                </td>
                <td className="collapsing no-print">
                    {this.props.canAddSoggetto ?
                        <a className="ui light grey icon button" onClick={(ev) => (this.props.onAddSoggetto(ev, c))}>
                            <i className="square outline icon"/>
                        </a>
                        :
                        <a className="ui blue icon button">
                            <i className="check icon"/>
                        </a>
                    }
                    {btnEdit}
                    {btnDelete}
                </td>
            </tr>)
    }
}

export default RubricaTableRow;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaTableRow.js
 **/